import { render, staticRenderFns } from "./entry_match_shortcut.vue?vue&type=template&id=7fbabb2d&scoped=true&"
import script from "./entry_match_shortcut.vue?vue&type=script&lang=js&"
export * from "./entry_match_shortcut.vue?vue&type=script&lang=js&"
import style0 from "./entry_match_shortcut.vue?vue&type=style&index=0&id=7fbabb2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbabb2d",
  null
  
)

export default component.exports